import React from "react";
import { FiPhone, FiMail,  } from "react-icons/fi";
import { CiInstagram } from "react-icons/ci";

function PlasticAndCosmestics() {
  return (
    <main className="main">

      {/* Page Title */}
      <div className="page-title dark-background">
        <div className="container text-center">
          <h1 className="page-heading">MPC – Makkah Plastic & Cosmetics</h1>
          <p className="page-subtitle">
            Quality plastic goods, household essentials & cosmetic products
          </p>
          <nav className="breadcrumbs">
            <ol>
              <li><a href="/">Home</a></li>
              <li className="current">Plastic & Cosmetics</li>
            </ol>
          </nav>
        </div>
      </div>

      {/* Content Section */}
      <section className="service-details section">
        <div className="container">

             {/* Main Image */}
          <div className="main-image-container">
            <img
              src="/assets/plastic/plastic-1.webp"
              alt="Logistics Services"
              className="main-image"
            />
          </div>

          {/* OVERVIEW */}
          <h2>Over-View</h2>
          <p>
            Our MPC Branch in Makkah is a dedicated store offering a wide range of
            plastic products, food containers, household washing items, and
            premium cosmetic products. Designed to serve both retail and bulk
            customers, this branch provides essential daily-use items with
            consistent quality and competitive pricing.
          </p>
          <p>
            We supply durable plastic goods including storage containers, food
            boxes, disposable items, cleaning tools, and kitchen-use products
            that support restaurants, homes, and commercial establishments.
          </p>

          {/* BRANCH PROFILE */}
          <h2>Branch Profile</h2>
          <p>
            The MPC Branch in Makkah operates as a specialized store providing a
            wide variety of plastic products, food containers, household washing
            items, and cosmetic products. This branch serves both retail and
            wholesale customers with durable and high-quality items.
          </p>
          <p>
            With well-organized sections, proper stock management, and a
            customer-friendly service approach, the MPC Branch ensures quick
            access to essential items and smooth purchasing. Located within the
            Haram boundary, the branch plays a key role in supplying reliable
            plastic goods and beauty products to homes, shops, restaurants, and
            businesses.
          </p>

          {/* PRODUCTS */}
          <h2>Products</h2>

          <h3>1. Plastic Household Items</h3>
          <div className="product-row">
            Storage containers, Food storage boxes, Airtight containers, Water
            bottles, Jugs & pitchers, Buckets, Basins, Laundry baskets, Waste
            bins, Plastic stools & chairs, Cutting boards, Trays, Ice boxes,
            Drawer organizers
          </div>

          <h3>2. Disposable & Food Packaging Items</h3>
          <div className="product-row">
            Disposable food containers, Meal boxes, Salad boxes, Hinged
            containers, Plastic cups, Paper cups, Plates, Bowls, Cutlery,
            Cling film, Aluminum foil, Takeaway bags, Garbage bags, Packaging
            rolls
          </div>

          <h3>3. Cleaning & Washing Items</h3>
          <div className="product-row">
            Mops, Mop buckets, Brooms, Brushes, Scrubbers, Sponges, Wipes,
            Cleaning gloves, Spray bottles, Dustpans, Squeegees, Laundry
            brushes, Soap trays
          </div>

          <h3>4. Kitchen & Household Utility Items</h3>
          <div className="product-row">
            Hotpots, Casseroles, Lunch boxes, Measuring cups, Mixing bowls,
            Strainers, Colanders, Ice cube trays, Serving trays, Spice
            containers, Knife sets, Dish racks
          </div>

          <h3>5. Cosmetics & Personal Care</h3>
          <div className="product-row">
            Shampoo & conditioners, Hair oils, Creams & gels, Body lotions,
            Moisturizers, Face wash, Soaps, Perfumes, Deodorants, Makeup
            essentials, Skincare creams, Hair serums, Hand wash, Baby-care
            products
          </div>

          <h3>6. Hygiene & Bath Items</h3>
          <div className="product-row">
            Toothbrushes, Toothpaste, Towels, Bath sponges, Body scrubbers,
            Shower caps, Cotton buds, Wet wipes, Sanitary napkins, Shaving
            items
          </div>

          <h3>7. Salon & Beauty Accessories</h3>
          <div className="product-row">
            Hairbrushes, Combs, Hair clips, Hair dryers, Straighteners, Curlers,
            Mirrors, Makeup pouches, Beauty kits
          </div>

          <h3>8. Commercial & Restaurant Supply Items</h3>
          <div className="product-row">
            Commercial food containers, Bulk takeaway boxes, Strong garbage
            bags, Commercial cleaning items, Storage bins, Plastic crates,
            Disposable gloves, Aprons
          </div>

          <h3>9. Miscellaneous Plastics</h3>
          <div className="product-row">
            Flower pots, Plastic shelves, Shoe racks, Storage cabinets,
            Multipurpose organizers
          </div>

        </div>
      </section>

      {/* Contact */}
      <section className="contact-strip">
        <div className="container">
          <h3 className="contact-heading">Contact</h3>
          <div className="contact-row">
            <span><FiPhone /> +966 55 0750167</span>
            {/* <span><FiMail /> example@email.com</span> */}
            <a
                           href="https://www.instagram.com/almac_company?igsh=MThmemIyN2d6aG8zeQ=="
                           target="_blank"
                           rel="noopener noreferrer"
                         >
                          <CiInstagram style={{ fontSize: '28px', color: '#111' }} />

                         </a>
          </div>
        </div>
      </section>

      {/* Styles */}
      <style>{`
        .page-heading {
          font-size: 3rem;
          font-weight: 800;
          color: #fff;
          text-shadow: 2px 2px 5px rgba(0,0,0,0.6);
          margin-bottom: 10px;
        }

        .page-subtitle {
          font-size: 1.2rem;
          color: #e6e6e6;
          margin-bottom: 15px;
        }

        h2 {
          font-size: 2rem;
          margin-top: 30px;
          margin-bottom: 15px;
          color: #222;
        }

        h3 {
          font-size: 1.6rem;
          margin-top: 25px;
          margin-bottom: 12px;
          color: #333;
        }

        p,
        .product-row {
          font-size: 1.1rem;
          line-height: 1.8;
          color: #555;
          margin-bottom: 12px;
        }

        .product-row {
          display: flex;
          flex-wrap: wrap;
          gap: 12px;
        }
          .main-image-container {
          text-align: center;
          margin-bottom: 35px;
        }

        .main-image {
          width: 100%;
          max-width: 900px;
          height: auto;
          border-radius: 12px;
        }

        .contact-strip {
          background: #fafafa;
          border-top: 1px solid #eee;
          margin-top: 50px;
          padding: 40px 0;
        }

        .contact-heading {
          text-align: center;
          font-size: 1.7rem;
          margin-bottom: 20px;
          font-weight: 700;
          color: #222;
        }

        .contact-row {
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 25px;
          flex-wrap: wrap;
          font-size: 1rem;
          color: #333;
        }

        .contact-row span {
          display: flex;
          align-items: center;
          gap: 8px;
          font-weight: 500;
        }

        @media (max-width: 576px) {
          .product-row {
            flex-direction: column;
            gap: 6px;
          }
        }
      `}</style>
    </main>
  );
}

export default PlasticAndCosmestics;
